export function useNewsletter() {
  const newsletter = useCookie<boolean>('nwslt', {
    decode: value => value === 'true',
    encode: value => String(value),
    maxAge: 60 * 60 * 24 * 365,
  })

  async function subscribe(email: string): Promise<void> {
    await $fetch('/newsletter', {
      method: 'POST',
      body: {email},
    })

    newsletter.value = true
  }

  return {
    newsletter,
    subscribe,
  }
}
